/**
 * FLOWER EXPRESS — SHOPIFY THEME JS
 * Handles: mobile nav, search drawer, cart AJAX, quick add, tab switching, location picker
 */

document.addEventListener('DOMContentLoaded', () => {

  /* ── MOBILE MENU ── */
  const mobileToggle = document.getElementById('mobile-menu-toggle');
  const mobileNav    = document.getElementById('mobile-nav');

  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', () => {
      const isOpen = !mobileNav.hidden;
      mobileNav.hidden = isOpen;
      mobileToggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  /* ── SEARCH DRAWER ── */
  const searchToggle = document.getElementById('search-toggle');
  const searchDrawer = document.getElementById('search-drawer');

  if (searchToggle && searchDrawer) {
    searchToggle.addEventListener('click', () => {
      const isOpen = !searchDrawer.hidden;
      searchDrawer.hidden = isOpen;
      searchToggle.setAttribute('aria-expanded', String(!isOpen));
      if (!isOpen) {
        const input = searchDrawer.querySelector('.search-input');
        if (input) input.focus();
      }
    });

    // Close drawer on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !searchDrawer.hidden) {
        searchDrawer.hidden = true;
        searchToggle.setAttribute('aria-expanded', 'false');
        searchToggle.focus();
      }
    });
  }

  /* ── AJAX ADD TO CART ── */
  async function addToCart(variantId, quantity = 1, buttonEl, properties = {}) {
    if (!variantId) return;

    const originalText = buttonEl ? buttonEl.textContent : '';
    if (buttonEl) {
      buttonEl.textContent = '✓';
      buttonEl.disabled = true;
    }

    const payload = { id: variantId, quantity };
    if (properties && Object.keys(properties).length > 0) {
      payload.properties = properties;
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error('Cart add failed');

      // Update cart count
      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();
      const cartCount = document.getElementById('cart-count');
      if (cartCount) {
        cartCount.textContent = cartData.item_count;
        cartCount.classList.add('cart-count-bump');
        setTimeout(() => cartCount.classList.remove('cart-count-bump'), 400);
      }

      // Button feedback
      if (buttonEl) {
        setTimeout(() => {
          buttonEl.textContent = originalText;
          buttonEl.disabled = false;
        }, 1500);
      }

    } catch (err) {
      console.error('Add to cart error:', err);
      if (buttonEl) {
        buttonEl.textContent = '!';
        setTimeout(() => {
          buttonEl.textContent = originalText;
          buttonEl.disabled = false;
        }, 1500);
      }
    }
  }

  window.addToCart = addToCart;

  /* ── ADD-TO-CART BUTTONS ── */
  document.addEventListener('click', (e) => {
    // Small + button on cards
    if (e.target.matches('.add-btn')) {
      e.preventDefault();
      const variantId = e.target.dataset.variantId;
      addToCart(variantId, 1, e.target);
    }

    // Quick add overlay button
    if (e.target.matches('.quick-add-btn')) {
      e.preventDefault();
      const variantId = e.target.dataset.variantId;
      addToCart(variantId, 1, e.target);
    }
  });

  /* ── PRODUCT TAB SWITCHING ── */
  window.switchTab = function(index, el) {
    document.querySelectorAll('.tab').forEach(t => t.classList.remove('active'));
    if (el) el.classList.add('active');
    // Could be extended with AJAX collection fetching
  };

  /* ── SCROLL ANIMATIONS ── */
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.usp-card, .product-card, .review-card, .hiw-step').forEach(el => {
      el.classList.add('fade-on-scroll');
      observer.observe(el);
    });
  }

  /* ── SMOOTH HEADER SCROLL ── */
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ── LOCATION PICKER ── */
  (function () {
    const toggle   = document.getElementById('location-toggle');
    const drawer   = document.getElementById('location-drawer');
    const input    = document.getElementById('location-search-input');
    const results  = document.getElementById('location-results');
    const pillText = document.getElementById('location-pill-text');

    if (!toggle || !drawer || !input || !results) return;

    let allLocations = [];
    let dataLoaded = false;

    function flattenLocations(data) {
      // Svako mjesto iz "locations" niza, s nazivom nadređenog grada ako postoji (za prikaz)
      const byId = {};
      (data.locations || []).forEach(loc => { byId[loc.id] = loc; });

      return (data.locations || []).map(loc => {
        const parent = loc.parent ? byId[loc.parent] : null;
        return {
          id: loc.id,
          name: loc.name,
          county: loc.county,
          searchText: [loc.name, ...(loc.aliases || [])].join(' ').toLowerCase(),
          parentName: parent ? parent.name : null
        };
      });
    }

    async function loadLocations() {
      if (dataLoaded) return;
      try {
        const url = window.FE_DELIVERY_DATA_URL;
        if (!url) throw new Error('FE_DELIVERY_DATA_URL nije postavljen');

        // Cache u sessionStorage da ne dohvaćamo file na svakoj stranici
        const cached = sessionStorage.getItem('fe_delivery_data');
        let data;
        if (cached) {
          data = JSON.parse(cached);
        } else {
          const res = await fetch(url);
          data = await res.json();
          sessionStorage.setItem('fe_delivery_data', JSON.stringify(data));
        }

        allLocations = flattenLocations(data);
        dataLoaded = true;
      } catch (err) {
        console.error('Greška kod učitavanja delivery-data.json:', err);
        results.innerHTML = '<div class="location-no-results">Trenutno nije moguće učitati popis mjesta.</div>';
      }
    }

    function renderResults(query) {
      const q = query.trim().toLowerCase();
      const matches = q === ''
        ? allLocations.slice(0, 8)
        : allLocations.filter(loc => loc.searchText.includes(q)).slice(0, 8);

      if (matches.length === 0) {
        results.innerHTML = '<div class="location-no-results">Nema rezultata za taj naziv.</div>';
        return;
      }

      results.innerHTML = matches.map(loc => `
        <div class="location-result-item" data-id="${loc.id}" data-name="${loc.name}" role="button" tabindex="0">
          <span>${loc.name}</span>
          <span class="location-result-county">${loc.parentName ? '· ' + loc.parentName + ' okolica' : (loc.county || '')}</span>
        </div>
      `).join('');
    }

    async function selectLocation(id, name) {
      localStorage.setItem('fe_location_id', id);
      localStorage.setItem('fe_location_name', name);
      if (pillText) pillText.textContent = name;

      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              location: name,
              location_id: id
            }
          })
        });
      } catch (err) {
        console.error('Greška kod spremanja lokacije u košaricu:', err);
      }

      drawer.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }

    // Prikaži spremljeni izbor pri učitavanju stranice
    const savedName = localStorage.getItem('fe_location_name');
    if (savedName && pillText) pillText.textContent = savedName;

    toggle.addEventListener('click', async () => {
      const isOpen = !drawer.hidden;
      drawer.hidden = isOpen;
      toggle.setAttribute('aria-expanded', String(!isOpen));
      if (!isOpen) {
        await loadLocations();
        renderResults('');
        input.focus();
      }
    });

    input.addEventListener('input', () => renderResults(input.value));

    results.addEventListener('click', (e) => {
      const item = e.target.closest('.location-result-item');
      if (!item) return;
      selectLocation(item.dataset.id, item.dataset.name);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !drawer.hidden) {
        drawer.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  })();

});
   